import { Platform } from "react-native";
import { config } from "../config";

export interface SubdomainCheck {
  isSubdomain: boolean;
  subdomain: string | null;
}

export const checkSubdomain = (): SubdomainCheck => {
  if (Platform.OS !== "web") {
    console.log("Not a web platform");
    return { isSubdomain: false, subdomain: null };
  }

  const hostname = window.location.hostname;
  console.log("Checking subdomain for hostname:", hostname);
  console.log("PWA domain:", config.pwa.domain);

  const isMatchingSubdomain =
    hostname.endsWith(`.${config.pwa.domain}`) &&
    hostname !== `www.${config.pwa.domain}`;

  console.log("Is matching subdomain:", isMatchingSubdomain);

  if (isMatchingSubdomain) {
    const subdomain = hostname.replace(`.${config.pwa.domain}`, "");
    console.log("Extracted subdomain:", subdomain);
    return { isSubdomain: true, subdomain };
  }

  console.log("No valid subdomain found");
  return { isSubdomain: false, subdomain: null };
};
